import sellyApi from './sellyApi'

export const CATALOGO_NAVIDAD_LLAVE = 'navidad-2026'
export const CATALOGO_PREFIJO = '/catalogo'

export function segmentoCatalogo(data) {
  if (!data || typeof data.ruta_pagina !== 'string') {
    return null
  }

  return segmentoDe(data.ruta_pagina)
}

export function rutaPaginaDe(data) {
  const segmento = segmentoCatalogo(data)
  if (!segmento) {
    return null
  }

  return `${CATALOGO_PREFIJO}/${segmento}`
}

export function catalogoPublico(data) {
  const rutaPagina = rutaPaginaDe(data)
  if (!data || data.visible !== true || !rutaPagina || !esUrlPublica(data.pdf_url)) {
    return null
  }

  const textoBoton = typeof data.texto_boton === 'string' ? data.texto_boton.trim() : ''
  if (textoBoton === '') {
    return null
  }

  return {
    textoBoton,
    pdfUrl: data.pdf_url,
    bannerUrl: esUrlPublica(data.banner_url) ? data.banner_url : null,
    qrUrl: esUrlPublica(data.qr_url) ? data.qr_url : null,
    piezaUrl: esUrlPublica(data.pieza_url) ? data.pieza_url : null,
    rutaPagina,
  }
}

export const getCatalogoDescarga = async (llave) => catalogoPublico(await pedirCatalogo(llave))

export const resolverCatalogoDescarga = async (llave) => {
  const data = await pedirCatalogo(llave)
  return {
    segmento: segmentoCatalogo(data),
    publico: catalogoPublico(data),
  }
}

async function pedirCatalogo(llave) {
  try {
    const { data } = await sellyApi.get(`/catalogo-descarga/${encodeURIComponent(llave)}`)
    return data
  } catch (error) {
    return null
  }
}

function segmentoDe(ruta) {
  let limpia = ruta.trim().replace(/^\/+|\/+$/g, '')
  const prefijo = `${CATALOGO_PREFIJO.slice(1)}/`
  if (limpia.startsWith(prefijo)) {
    limpia = limpia.slice(prefijo.length)
  }

  if (!/^[A-Za-z0-9_-]+$/.test(limpia) || limpia.length > 200) {
    return null
  }

  return limpia
}

function esUrlPublica(url) {
  if (typeof url !== 'string' || url === '') {
    return false
  }

  try {
    const parsed = new URL(url)
    return parsed.protocol === 'https:' || parsed.protocol === 'http:'
  } catch (error) {
    return false
  }
}
